import cx from 'classnames';
import { Image, Text, useIntl } from 'platform-components/common';
import React from 'react';

import { problemsStubTextSizeMap } from './constants';
import { PROBLEMS_STUB_SIZE } from './typings';

interface Props {
    textId: string;
    mix?: string;
    size?: PROBLEMS_STUB_SIZE;
}

import './problems-stub.scss';

export const ProblemsStub = React.memo(({ textId, mix, size = PROBLEMS_STUB_SIZE.L }: Props) => {
    const intl = useIntl();

    return (
        <div className={cx('problems-stub', mix)}>
            <Image
                alt={intl.formatMessage({ id: 'problemsStub.imgAlt' })}
                className="problems-stub__img"
                src={intl.formatMessage({ id: 'problemsStub.img.v2' })}
            />
            <Text id={textId} size={problemsStubTextSizeMap[size]} type={Text.TYPE.MARKDOWN} />
        </div>
    );
});
